import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  justify-content: center;
`;

export const StarContainer = styled.div`
  width: 50px;
  height: 54px;
  padding: 0px 6px;
  display: flex;
  justify-content: center;
  align-self: start;
  align-items: center;
`;

